import * as icon from './icons';

export type IIcon = keyof typeof Icons;

export interface IconProps {
  className?: string;
  icon: IIcon;
  srText?: string;
  color?: string;
  width?: number;
  height?: number;
}

export interface SVGProps {
  className?: string;
  color?: string;
  width?: number;
  height?: number;
  state?: number; // state can be given as 0,1,2 etc to show the svg in a particular state
}

export const Icons = {
  blocks: icon.Blocks,
  check: icon.Check,
  chevron: icon.Chevron,
  close: icon.Close,
  cog: icon.Cog,
  contensis: icon.Contensis,
  dragIndicator: icon.DragIndicator,
  dropdown: icon.Dropdown,
  edit: icon.Edit,
  eye: icon.Eye,
  emptyAudiences: icon.EmptyAudiences,
  emptyBlocks: icon.EmptyBlocks,
  gitlab: icon.Gitlab,
  link: icon.Link,
  listCheck: icon.ListCheck,
  listEdit: icon.ListEdit,
  logout: icon.Logout,
  personalization: icon.Personalization,
  play: icon.Play,
  refresh: icon.Refresh,
  remove: icon.Remove,
  share: icon.Share,
  triangle: icon.Triangle,
  user: icon.User,
  warning: icon.Warning,
};

export enum IconsDictionary {
  Blocks = 'blocks',
  Check = 'check',
  Chevron = 'chevron',
  Close = 'close',
  Cog = 'cog',
  Contensis = 'contensis',
  DragIndicator = 'dragIndicator',
  Dropdown = 'dropdown',
  Edit = 'edit',
  Eye = 'eye',
  EmptyAudiences = 'emptyAudiences',
  EmptyBlocks = 'emptyBlocks',
  Gitlab = 'gitlab',
  Link = 'link',
  ListCheck = 'listCheck',
  ListEdit = 'listEdit',
  Logout = 'logout',
  Personalization = 'personalization',
  Play = 'play',
  Refresh = 'refresh',
  Remove = 'remove',
  Share = 'share',
  Triangle = 'triangle',
  User = 'user',
  Warning = 'warning',
}
